module.exports = __webpack_public_path__ + "img/Simulation-FoundationBlock.aa67a7bf.jpeg";